
import { motion } from "framer-motion";
import ReactQuill from "react-quill-new";

export const ShortAnswerOption = () => {

    return (
        <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
        <ReactQuill />

    </motion.div>
    )
}